import React, { useState } from "react";
import SparkLine from "../sparkline/SparkLine";
import { SparkLineProps } from "../sparkline/SparkLineTypes";

const SparkLineAdvanced: React.FC<SparkLineProps> = props => {
  const [currentBiggestValueLabelWidth, setCurrentBiggestValueLabelWidth] = useState<number>(0);

  if (props.isMultipleCharts) {
    return (
      <div className="flex flex-column gap-3">
        <SparkLine
          {...props}
          advanced
          generalProperties={props.generalProperties}
          isMultipleCharts
          currentBiggestValueWidth={currentBiggestValueLabelWidth}
          setCurrentBiggestValueWidth={setCurrentBiggestValueLabelWidth}
        />
        {props.multipleCharts.map((chart, index) => (
          <SparkLine
            key={chart.id ?? index}
            {...chart}
            advanced
            generalProperties={props.generalProperties}
            isMultipleCharts
            currentBiggestValueWidth={currentBiggestValueLabelWidth}
            setCurrentBiggestValueWidth={setCurrentBiggestValueLabelWidth}
          />
        ))}
      </div>
    );
  }
  return <SparkLine {...props} advanced />;
};

export default SparkLineAdvanced;
